/**
 * Enum used to detect skill update action
 */

export enum SkillUpdateType {
    Rollback, /** Used to rollback ML Skill to previous version */
    Update, /** Used to update ML Skill to any version */
    Modifying, /** Used to modifying hardware requirement for ML Skill */
}
